import { gql } from '@apollo/client';

/** Shared enum / reference-data queries used across features. */

export const GET_SUPPORTED_LANGUAGES = gql`
  query GetSupportedLanguages {
    getSupportedLanguages {
      code
      displayName
      isTranslationActive
    }
  }
`;

export const GET_VENDOR_TYPES = gql`
  query GetVendorTypes($languageCode: String) {
    getVendorTypes(languageCode: $languageCode) {
      name
      value
      displayValue
    }
  }
`;

export const GET_VENDOR_SUBTYPES = gql`
  query GetVendorSubtypes($vendorType: String!, $languageCode: String) {
    getVendorSubtypes(vendorType: $vendorType, languageCode: $languageCode) {
      name
      value
      vendorType
      displayValue
    }
  }
`;

export const GET_DAY_OF_WEEK = gql`
  query GetDayOfWeek($languageCode: String) {
    getDayOfWeek(languageCode: $languageCode) {
      displayValue
      enumName
      value
    }
  }
`;

export const ERASE_USER_PROFILE = gql`
  mutation EraseUserProfile($userId: String!) {
    eraseUserProfile(userId: $userId) {
      success
      message
      daysActive
      errors {
        code
        field
        message
      }
    }
  }
`;
